import { render } from "./DashboardCard.vue?vue&type=template&id=3e544870"
import script from "./DashboardCard.vue?vue&type=script&lang=js"
export * from "./DashboardCard.vue?vue&type=script&lang=js"

import exportComponent from "D:\\PHPStormProjects\\hqam-customer-portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__